import React from 'react';
import './Loader.css';

const Loader = () => {
    return (
        <div>
            <div className="body-loader8">
                <div className="container-loader8">
                    <div className="loader-loader8 loader8"></div>
                </div>
            </div>
        </div>
    );
};

export default Loader;